"use strict";
class clanopedia {
    constructor() {
        this.initPageConfig();
    }
    initPageConfig() {
        const buttonClan = document.querySelectorAll(".abi__btn-clanopedia-clan");
        if (buttonClan) {
            buttonClan.forEach((button) => {
                button.addEventListener('click', function () {
                    const idElementToShow = this.getAttribute('data-show-element');
                    if (idElementToShow) {
                        const ElementToShow = document.querySelector(`#${idElementToShow}`);
                        if (ElementToShow) {
                            ElementToShow.classList.remove("hidden");
                            const y = ElementToShow.getBoundingClientRect().top + window.scrollY;
                            window.scroll({
                                top: y,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            });
        }
        document.addEventListener("click", function (e) {
            const target = e.target.closest('.abi__button-top');
            if (target) {
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }
}
window.addEventListener('load', function () {
    new clanopedia();
});
